module.exports = __webpack_public_path__ + "media/assets/faria_products/CAM-ADV-81a074dfc42a5d627087d55866f7174ed62d35bbef3debc5c2d4d7136137883e.png";